import { useEffect, useState } from 'react'
import { useRemoteClientPost } from '../../../../../../configs/http-client'
import { CatchMessageError } from '../../../../../../remote/catch-message-error'
import { useLocalStorage } from '../../../../../../remote/local-storage'

export const LoadCostCenter = () => {
  const { getUnitId } = useLocalStorage()
  const { httpClientPost } = useRemoteClientPost()
  const [data, setData] = useState<any[] | null>(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!loading) {
      setLoading(true)
      httpClientPost('/centro-custo/filtro?page=0&size=100000', {
        unidadeId: getUnitId()
      })
        .then((response) => {
          setData(
            response.data.data.content.map((item: any) => ({
              ...item,
              label: item.descricao,
              value: item.id
            }))
          )
        })
        .catch(CatchMessageError)
        .finally(() => setLoading(false))
    }
  }, [])

  return {
    data
  }
}
